module.exports = __webpack_public_path__ + "static/img/egg_b_04.e89e3f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_04.png
// module id = iuRL
// module chunks = 1